import socketIOClient from "socket.io-client";

class SocketRequester {
  instance = null;

  constructor() {
    this.instance = socketIOClient(process.env.REACT_APP_SOCKET, {
      reconnectionAttempts: 10,
    });
  }

  subscribe(url, method) {
    let instance = this.instance;
    instance.on(url, method);
    instance.emit("subscribe", url);
  }
  unSubscribe(url) {
    let instance = this.instance;
    instance.off(url);
    instance.emit("unsubscribe", url);
  }

  publish(url, data) {
    let instance = this.instance;
    return instance.emit(url, data);
  }
}

export default SocketRequester;
